<template>
  <div>
    <a
      href="#"
      @click="click"
    >
      {{ grapesJSInstance === null ? 'Copy' : 'Select' }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  inject: ['onClick'],
  data () {
    return {
      data: {}
    }
  },
  computed: {
    ...mapGetters({
      grapesJSInstance: 'getGrapesJSInstance'
    })
  },
  methods: {
    click () {
      const { value } = this.data
      if (value) {
        this.onClick(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
